import _ from 'lodash';
import React from 'react';
import ReactTooltip from 'react-tooltip';

import helpers from 'helpers';

import { letterMapper, AnnotationTooltip } from 'helpers/annotations';

class ContentAnnotations extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            characters: [],
            tooltips: [],
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { textLetter, annotations } = nextProps;

        if (this.props.textLetter === textLetter
            && _.isEqual(this.props.annotations, annotations)) {
            return;
        }

        if (annotations.length > 0) {
            const characters = this.createCharacters(textLetter, annotations);
            const tooltips = this.createTooltips(characters);
    
            this.setState({
                characters,
                tooltips,
            });
        }
        else {
            this.setState({
                characters: undefined,
                tooltips: undefined,
            });
        }
    }

    createCharacters(textLetter, annotations) {
        let characters = textLetter.split('');

        characters = characters.map((symbol, symbolPosition) => {
            symbol = symbol === ' ' ? '\u00A0' : symbol;

            return {
                symbol,
                symbolPosition,
                style: {},
                ids: [],
                tooltipContent: [],
            };
        });

        annotations.sort((a, b) => {
            if (a.priority > b.priority) {
                return -1;
            }

            if (a.priority < b.priority) {
                return 1;
            }

            return 0;
        });

        for (let i = 0; i < annotations.length; i++) {
            const hashColor = helpers.createHashColor();

            for (let j = annotations[i].start; j < annotations[i].end; j++) {
                if (annotations[i].styles.background === '') {
                    characters[j].style = {
                        ...annotations[i].styles,
                        background: hashColor,
                    };
                } else {
                    characters[j].style = annotations[i].styles;
                }

                characters[j].ids.push(annotations[i].id);
                characters[j].tooltipContent.push({
                    rule: annotations[i].features.rule,
                    type: annotations[i].type,
                });
            }
        }

        return characters;
    }

    createTooltips(characters) {
        const map = new Map();
        for (const char of characters) {
            map.set(char.ids.join(''), char);
        }
        return Array.from(map.values());
    }

    render() {
        const { tooltips, characters } = this.state;
        const { textLetter } = this.props;

        return (
            <div>
                <div className='letter-text'>
                    {
                        characters
                            ? Array.from(letterMapper(characters))
                            : textLetter
                    }
                </div>
                <AnnotationTooltip tooltips={tooltips} renderTooltip={tooltip => (
                    <div className='tooltip-row'>
                        {
                            tooltip.tooltipContent.map((t, k) => {
                                let rule = t.rule && `Rule - ${t.rule}, `;

                                return (<div key={k} className='tooltip-column'>
                                    <div className='col'>{rule}</div>
                                    <div className='col'>{`Type - ${t.type}`}</div>
                                </div>);
                            })
                        }
                    </div>
                )} />
            </div>
        );
    }
}

export default ContentAnnotations;



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/Content/Annotations.jsx